import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { LinkButton, Spacing, Text } from '@reservamos/elements';
import moment from 'moment';
import LocalizedCurrency from 'components/LocalizedCurrency';
import 'styles/components/purchase/TicketsPanel';
import PaymentImage from '../../../ui/atoms/PaymentImage';

/**
 * OxxoPaymentInfo component.
 * @param {object} props - amount, pdfUrl, paydayLimit, reference
 * @param {number} props.amount - Amount of the payment
 * @param {string} props.pdfUrl - URL of the PDF
 * @param {string} props.paydayLimit - Payday limit
 * @param {string} props.reference - Reference
 * @returns {JSX.Element} - OxxoPaymentInfo component
 */
const OxxoPaymentInfo = ({ amount, pdfUrl, paydayLimit, reference }) => {
  const { t } = useTranslation('payment');
  const paydayLimitDisplay = moment(paydayLimit).format('LLLL');

  return (
    <div className="tickets-panel">
      <div className="tickets-panel-content">
        <Spacing vertical size="S" alignItems="flex-start">
          <PaymentImage type="oxxo-logo" />
          <Text size="S">
            <Trans i18nKey="text.bring_payment_reference_to_pay" t={t}>
              text<b>text</b>text
            </Trans>
          </Text>
        </Spacing>
      </div>
      <div className="tickets-panel-content right-content">
        <div className="right-content-info">
          <Spacing vertical size="L">
            <Spacing vertical size="S">
              <Text size="S" textAlign="center" color="grayMedium">
                {t('purchase:label.payment_reference')}:
              </Text>
              <Text size="XL" weight="bold" textAlign="center">
                {reference}
              </Text>
              <Text textAlign="center">
                <LinkButton
                  borderRadius
                  href={pdfUrl}
                  iconColor="white"
                  iconType="Download"
                  newTab
                  padding="M"
                  variant="accent"
                  text={t('button.print_payment_reference')}
                />
              </Text>
            </Spacing>
            <Spacing vertical size="S">
              <Text size="S" textAlign="center" color="grayMedium">
                {t('label.payday_limit')}:
              </Text>
              <Text size="XL" weight="bold" textAlign="center">
                {paydayLimitDisplay}
              </Text>
            </Spacing>
          </Spacing>
        </div>
        <div className="right-content-price">
          <Spacing vertical size="S">
            <Text size="S" textAlign="center" color="grayMedium">
              {t('label.waiting_for_your_payment')}:
            </Text>
            <div className="right-content-price-amount text-center">
              <LocalizedCurrency price={amount} currencyStyle="currency" size="XL" weight="bold" />
            </div>
            <Text size="XS" italic>
              * {t('text.additional_commission_oxxo')}
            </Text>
          </Spacing>
        </div>
      </div>
    </div>
  );
};

OxxoPaymentInfo.propTypes = {
  amount: PropTypes.number.isRequired,
  paydayLimit: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
};

export default OxxoPaymentInfo;
